// Incoming-call ring for the advisor softphone: a short two-tone pattern generated with WebAudio (no audio asset).
// Without WebAudio (jsdom, very old browsers) it is a silent no-op; it never throws.

export interface RingTone {
  start(): void;
  stop(): void;
}

type AudioContextCtor = new () => AudioContext;

export function createRingTone(): RingTone {
  let ctx: AudioContext | null = null;
  let timer: ReturnType<typeof setInterval> | null = null;

  const burst = () => {
    if (!ctx) return;
    try {
      const t = ctx.currentTime;
      const gain = ctx.createGain();
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.15, t + 0.05);
      gain.gain.setValueAtTime(0.15, t + 0.9);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 1);
      gain.connect(ctx.destination);
      for (const freq of [440, 480]) {
        const osc = ctx.createOscillator();
        osc.frequency.value = freq;
        osc.connect(gain);
        osc.start(t);
        osc.stop(t + 1);
      }
    } catch {
      // Audio is best-effort: the in-app card is the primary signal.
    }
  };

  return {
    start() {
      if (timer) return;
      const Ctor = (globalThis as { AudioContext?: AudioContextCtor; webkitAudioContext?: AudioContextCtor }).AudioContext ?? (globalThis as { webkitAudioContext?: AudioContextCtor }).webkitAudioContext;
      if (!Ctor) return;
      try {
        ctx ??= new Ctor();
        void ctx.resume?.().catch(() => undefined);
      } catch {
        ctx = null;
        return;
      }
      burst();
      timer = setInterval(burst, 3000);
    },
    stop() {
      if (timer) clearInterval(timer);
      timer = null;
      const c = ctx;
      ctx = null;
      void c?.close?.().catch(() => undefined);
    },
  };
}
